goog.provide("shadow.js.shim.module$dayjs$locale$pl");
goog.provide("module$shadow_js_shim_module$dayjs$locale$pl");
shadow.js.shim.module$dayjs$locale$pl = shadow.js.nativeProvides["dayjs/locale/pl"] = require("dayjs/locale/pl");
module$shadow_js_shim_module$dayjs$locale$pl.default = shadow.js.shim.module$dayjs$locale$pl;
